import { useMemo, useContext } from 'react';
import ConfirmContext from './ConfirmContext.js';
/** Returns a function that when executed, shows a confirm dialog. Note: requires {@link ConfirmProvider}! */

var useConfirm = function useConfirm(baseOptions) {
  var confirmFactory = useContext(ConfirmContext);
  return useMemo(function () {
    if (!confirmFactory) {
      console.error("Provider for confirm context not found");
      return;
    }

    return confirmFactory(baseOptions);
  }, [baseOptions, confirmFactory]);
};

export { useConfirm };